import { render } from "./ManagerList.vue?vue&type=template&id=669685e6"
import script from "./ManagerList.vue?vue&type=script&lang=js"
export * from "./ManagerList.vue?vue&type=script&lang=js"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__